angular.module('ecrd.record.bulk', [
]);
